@use '~/vendor/cxy/scss/styles/index.scss' as cxy;

.verifyEmail .iconContainer {
  display: flex;
  align-items: center;
  justify-content: center;
}
.verifyEmail .icon {
  margin: var(--cxy-spacing-xsm) var(--cxy-spacing-xsm) var(--cxy-spacing-xsm) 0;
  color: var(--cxy-color-brand);
  height: 50px !important;
}
.verifyEmail .title {
  font-size: var(--cxy-fontSize-xxl);
  font-weight: bold;
  display: flex;
  align-items: center;
  color: var(--cxy-color-text-default-body);
}
.verifyEmail .content {
  @include cxy.stack(var(--cxy-spacing-xxsm));
}
.verifyEmail .text {
  font-size: var(--cxy-fontSize-m);
  color: var(--cxy-color-text-default-body);
}
.verifyEmail .resendLink {
  /* Reset native <button> chrome so this reads as inline text in the sentence, not a boxed control. */
  background: none;
  border: none;
  padding: 0;
  font: inherit;
  color: inherit;
  text-decoration: underline;
  cursor: pointer;
}
.verifyEmail .resendLink:disabled {
  cursor: default;
  opacity: 0.6;
}
.verifyEmail .errorMessage {
  font-size: var(--cxy-fontSize-m);
  color: var(--cxy-color-error);
}
